module.exports = __webpack_public_path__ + "media/images/map_icons/Dance-86f4631dfde1d8c3664d74a8bbad8bf7.svg";